const ArgentinaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_110776)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M19.9998 0C12.0706 0 5.21938 4.61445 1.98438 11.3044H38.0152C34.7803 4.61445 27.929 0 19.9998 0Z"
        fill="#338AF3"
      />
      <path
        d="M19.9998 39.9997C27.929 39.9997 34.7803 35.3852 38.0153 28.6953H1.98438C5.21938 35.3852 12.0706 39.9997 19.9998 39.9997Z"
        fill="#338AF3"
      />
      <path
        d="M25.9779 19.999L23.5354 21.148L24.8361 23.5135L22.1837 23.0061L21.8476 25.6855L20.0002 23.7148L18.1527 25.6855L17.8167 23.0061L15.1643 23.5134L16.465 21.1479L14.0225 19.999L16.465 18.85L15.1643 16.4845L17.8166 16.9919L18.1528 14.3125L20.0002 16.2831L21.8477 14.3125L22.1837 16.9919L24.8361 16.4845L23.5354 18.8501L25.9779 19.999Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_110776">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default ArgentinaSvg;
